import React, { useEffect, useRef, useState } from 'react';
import Form, { useForm } from '../../molecules/Form';
import Field from '../Field';
import Button from '../../molecules/Button';
import Toast from '../../molecules/Toast';
import { GoArrowLeft } from 'react-icons/go';
import campaignService from '../../../services/campaignService';
import { useLocation, useNavigate } from 'react-router-dom';
import { StyledCampaignSetting } from './CreateCompaign.styles';
import Loaders from '../Loaders';
import Select from '../../molecules/Select';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import Switch from '../Switch';
const Step8 = ({ goBack, setStep, data, setData, isEdit }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const campaignId = location?.state?.campaign_id;
  const campaignStatus = location?.state?.status;
  const campaignType = location?.state?.campaign_type;
  const [form] = useForm();
  const [loading, setLaoding] = useState(false);
  const [btnTrack, setBtnTrack] = useState(1);
  const [btnActive, setBtnActive] = useState(1);
  const [btnStop, setBtnStop] = useState(1);
  const campaignStatusRef = useRef('draft');
  const [draftLoading, setDraftLoading] = useState(false);
  const [emailAccountsData, setEmailAccountsData] = useState([]);
  const [actionType, setActionType] = useState('SMTP');
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const emailSelectRef = useRef(null);
  const { user } = useContextHook(AuthContext, v => ({
    user: v.user,
  }));

  const [searchQuery, setSearchQuery] = useState({
    page: 1,
    itemsPerPage: 10,
    startDate: '',
    endDate: '',
    search: '',
    start_time: '',
    end_time: '',
    getAll: true,
  });

  const { emails_loading, emails_data } = campaignService.GetAllEmails({ ...searchQuery }, fetch);
  const onSubmit = async payload => {
    try {
      const res = await campaignService.addEmailAccountsToCampaign(payload);
      if (res.success) {
        if (payload?.campaign_status === 'draft') {
          // navigate('/campaign-launched', { state: { draft: true } });
          navigate('/campaign-manager');
        } else {
          // Navigate with showStars flag only when launching (not draft)
          // Use sessionStorage as backup since location state can be lost
          sessionStorage.setItem('showStars', 'true');
          navigate('/campaign-manager');
        }
      }
      setData(prev => ({ ...prev, step8: payload }));
    } catch (error) {
      throw new Error(error.message);
    }
  };
  const handleDraft = async e => {
    if (draftLoading || loading) return;
    const { sender_email, autopilot } = form.getFieldsValue(['sender_email', 'autopilot']);

    const emailIds = sender_email?.map(item => item?.value);

    setDraftLoading(true);


    try {
      const payload = {
        campaignId: data?.step2?.campaignId || data?.step6?.campaignId || data?.campaignId || campaignId,
        senderIds: emailIds,
        actionType: actionType,
        campaign_status: 'draft',
        ...(campaignType === 'ai' && { auto_pilot: autopilot }),
        isMultiple: true,
        isEdit,
      };
      await onSubmit(payload);
    } catch (error) {
      Toast({ type: 'error', message: error.message });
    } finally {
      setDraftLoading(false);
    }
  };
  const handleSubmit = async e => {
    if (loading || draftLoading) return;
    const emailIds = e?.sender_email?.map(item => item?.value);
    setLaoding(true);
    try {
      const payload = {
        campaignId: data?.step2?.campaignId || data?.step6?.campaignId || data?.campaignId || campaignId,
        senderIds: emailIds,
        // max_leads_per_day:
        //   emailIds.length > 0
        //     ? data?.step7?.changes?.max_leads_per_day * emailIds.length
        //     : data?.step7?.changes?.max_leads_per_day,
        actionType: actionType,
        ...(campaignType === 'ai' && { auto_pilot: e?.autopilot }),
        campaign_status: 'running',
        isMultiple: true,
        isEdit,

      };
      await onSubmit(payload);

      setData(prev => ({ ...prev, step8: payload }));
    } catch (error) {
      Toast({ type: 'error', message: error.message });
    } finally {
      setLaoding(false);
    }
  };

  useEffect(() => {
    if (isEdit) {
      const getEmailAccounts = async () => {
        try {
          const res = await campaignService.getCampaignEmailAccounts(campaignId);
          setEmailAccountsData(res?.data?.emailAccounts);
          if (res?.actionType) {
            setActionType(res?.actionType);
          }
          form.setFieldsValue({ autopilot: res?.data?.autoPilot });
        } catch (err) {
          Toast({ type: 'error', message: err.message });
        }
      };
      getEmailAccounts();
    }
  }, [campaignId, isEdit]);

  let emailOptions = [];
  const selectedEmailIds = form.getFieldValue('sender_email')?.map(item => Number(item.value)) || [];
  if (emails_data?.data) {
    const emailsArr = actionType === 'SES' ? emails_data.data.ses : emails_data.data.smtp;

    emailOptions = (emailsArr || [])
      .filter(email => !selectedEmailIds.includes(Number(email.value)))
      .map(item => ({
        label: item.label,
        value: Number(item.value),
      }));
  }

  useEffect(() => {
    form.setFieldsValue({
      sender_email: [],
    });
  }, [actionType]);

  useEffect(() => {
    if (isEdit && emailAccountsData) {
      const sesLength = emails_data?.data?.ses?.length || 0;
      const smtpLength = emails_data?.data?.smtp?.length || 0;
      const sendersEmails = (Array.isArray(emailAccountsData) ? emailAccountsData : [])?.map(sender => {
        const allEmails = [...(emails_data?.data?.smtp ?? []), ...(emails_data?.data?.ses ?? [])];
        const matched = allEmails.find(email => Number(email.value) === Number(sender?.id));
        return matched ? { label: matched?.label, value: Number(matched?.value) } : null;
      })
        .filter(Boolean);


      form.setFieldsValue({
        sender_email: sendersEmails?.length > 0 ? sendersEmails : [],
      });

    }
  }, [isEdit, emailAccountsData, emails_data]);

  useEffect(() => {
    const handleClickOutside = e => {
      if (emailSelectRef.current && !emailSelectRef.current.contains(e.target)) {
        // Also check if click is on the editor container
        const editorContainer = document.querySelector('.editor-holder');
        if (editorContainer && editorContainer.contains(e.target)) {
          setMenuIsOpen(false);
        } else {
          setMenuIsOpen(false);
        }
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  useEffect(() => {
    if (menuIsOpen && emailSelectRef.current) {
      // Focus the select input when menu opens
      const selectInput = emailSelectRef.current.querySelector(
        'input[id*="sender_email"], input[aria-label*="Select"], .react-select__input input, input[type="text"]'
      );
      if (selectInput) {
        setTimeout(() => {
          selectInput.focus();
        }, 100);
      }
    }
  }, [menuIsOpen]);

  return (
    <StyledCampaignSetting>
      <div className="head">
        {/* <button onClick={() => setStep(8)}>
          <GoArrowLeft size={25} />
        </button> */}
        <div>
          <span className="heading">Review & Launch</span>
          <p>Check all your settings one last time. Save as draft, schedule, or launch your campaign immediately.</p>
        </div>
      </div>
      <Form form={form} onSubmit={handleSubmit}>
        {campaignType === "ai" && (
          <div className="col autopilot">
            <div>
              <span className="heading">Autopilot</span>
              <span className="text">Send AI generated messages without approving</span>
            </div>
            <div className="switch-holder">
              <Form.Item name="autopilot" noMargin>
                <Switch />
              </Form.Item>
            </div>
          </div>
        )}
        <div className="col">
          <div>
            <span className="heading">Track Open Rate Checker</span>
            <span className="text">Stop sending emails to a lead if a response has been received</span>
          </div>
          <div className="enable-disable-tabs">
            <button type="button" className={btnTrack === 1 && 'active'} onClick={() => setBtnTrack(1)}>
              Disable
            </button>
            <button type="button" className={btnTrack === 2 && 'active'} onClick={() => setBtnTrack(2)}>
              Enable
            </button>
          </div>
        </div>
        <div className="col">
          <div>
            <span className="heading">Activate Out of Office Detection</span>
            <span className="text">OOO replies are detected and the sequence resumes when the lead is back.</span>
          </div>
          <div className="enable-disable-tabs">
            <button type="button" className={btnActive === 1 && 'active'} onClick={() => setBtnActive(1)}>
              Disable
            </button>
            <button type="button" className={btnActive === 2 && 'active'} onClick={() => setBtnActive(2)}>
              Enable
            </button>
          </div>
        </div>
        <div className="col">
          <div>
            <span className="heading">Select E-Mail Type</span>
          </div>
          <div className="enable-disable-tabs">
            {new Date(user?.data?.created_at) < new Date('2026-03-09') && (
              <button
                type="button"
                // className={`${actionType === 'SES' ? ' domain-btn active':"domain-btn"} ${isEdit && emailAccountsData?.length > 0 && 'disabled-btn'}`}
                className={`${actionType === 'SES' && 'active'} ${isEdit && emailAccountsData?.length > 0 && 'disabled-btn'}`}
                onClick={() => setActionType('SES')}
                disabled={isEdit && emailAccountsData?.length > 0}
              >
                Domain Based
              </button>
            )}
            <button
              type="button"
              className={`${actionType === 'SMTP' && 'active'} ${isEdit && emailAccountsData?.length > 0 && 'disabled-btn'}`}
              onClick={() => setActionType('SMTP')}
              disabled={isEdit && emailAccountsData?.length > 0}
              style={{ borderRadius: new Date(user?.data?.created_at) < new Date('2026-03-09') ? '0 10px 10px 0' : '10px' }}
            >
              SMTP
            </button>
          </div>

        </div>
        <div className="col firs-col email-select">
          <div className="content-holder">
            <div>
              <span className="heading">Select E-Mail Accounts</span>
            </div>
            <div className="select-holder" ref={emailSelectRef}>
              {!menuIsOpen && (
                <span
                  className="select-placeholder"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    setMenuIsOpen(true);
                    // Focus the select input after a short delay to ensure it's rendered
                    setTimeout(() => {
                      const selectInput = emailSelectRef.current?.querySelector('input[id*="sender_email"], input[aria-label*="Select"], .react-select__input input');
                      if (selectInput) {
                        selectInput.focus();
                      }
                    }, 0);
                  }}>
                  Select email accounts
                </span>
              )}
              <Form.Item
                type="select"
                placeholder="Select email accounts"
                rounded
                name="sender_email"
                isMulti
                noMargin
                disabled={campaignStatus === 'completed'}
                staticPosition
                menuIsOpen={menuIsOpen}
                onMenuOpen={() => setMenuIsOpen(true)}
                onMenuClose={() => setMenuIsOpen(false)}
                rules={[
                  {
                    required: true,
                    message: 'Sender Email is required',
                  },
                ]}
                options={emailOptions}>
                <Field />
              </Form.Item>
            </div>
          </div>
          {/* <span className="grd-color">Connect new email account</span> */}
        </div>
        <div className="col">
          <div>
            <span className="heading">Stop sending emails on reply</span>
            <span className="text">Stop sending emails to a lead if a response has been received</span>
          </div>
          <div className="enable-disable-tabs">
            <button type="button" className={btnStop === 1 && 'active'} onClick={() => setBtnStop(1)}>
              Disable
            </button>
            <button type="button" className={btnStop === 2 && 'active'} onClick={() => setBtnStop(2)}>
              Enable
            </button>
          </div>
        </div>
        <div className="col">
          <div>
            <div className="delivery-head">
              <span className="heading">Delivery Optimization</span>
              <span className="tag">Recommended</span>
            </div>
            <span className="text">Disables open tracking</span>
          </div>
          <div className="checkbox-col">
            <Form.Item label="Send emails as text-only (no HTML)" type="checkbox" rounded name="no_html" noMargin>
              <Field />
            </Form.Item>
            <Form.Item label="Send first emails as text-only" type="checkbox" rounded name="first_email" noMargin>
              <Field />
            </Form.Item>
          </div>
        </div>
        {campaignStatus !== 'completed' && (
          <div className="btn-holder">
            {(campaignStatus !== 'running' && campaignStatus !== 'completed' && campaignStatus !== 'paused') ? (
              <div className="btn-wrap">
                <Button variant="outline" width="155px" rounded type="button" onClick={handleDraft} disabled={draftLoading || loading}>
                  {draftLoading ? <Loaders buttonLoader /> : <>Save as Draft</>}
                </Button>
                <Button variant="darkBlue" type="submit" width="155px" rounded loader={loading} disabled={loading || draftLoading}>
                  {isEdit ? 'Save' : 'Launch'}
                </Button>
              </div>
            ) :
              <Button variant="darkBlue" type="submit" width="155px" rounded loader={loading} disabled={loading || draftLoading}>
                {isEdit ? 'Save' : 'Launch'}
              </Button>
            }
          </div>
        )}
      </Form>
    </StyledCampaignSetting>
  );
};

export default Step8;
